module.exports = __webpack_public_path__ + "img/workspace-ready.eb3b00b5.png";